import { P } from 'ts-pattern'

export const isDefined = P.when((value) => value !== undefined)

export const exists = P.when((value) => Boolean(value))
